/**
 * 布局：左、中、右
 */

import React from 'react';
import classNames from 'classnames';


import './style.css';


export default function Layout(props) {
  let {className, children, ...rest} = props;
  let cls = classNames('day-trip-layout', className);

  return (
    <section {...rest} className={cls}>{children}</section>
  );
}


export function LayoutHeader(props) {
  let {className, children, ...rest} = props;
  let cls = classNames('day-trip-layout-header', className);

  return (
    <header {...rest} className={cls}>{children}</header>
  );
}


export function LayoutBody(props) {
  let {className, children, ...rest} = props;
  let cls = classNames('day-trip-layout-body', className);

  return (
    <main {...rest} className={cls}>{children}</main>
  );
}


export function LayoutFooter(props) {
  let {className, children, ...rest} = props;
  let cls = classNames('day-trip-layout-footer', className);

  return (
    <footer {...rest} className={cls}>{children}</footer>
  );
}



// WEBPACK FOOTER //
// ./src/pages/trip/Trip/DayTrip/Layout/index.js